<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Employees</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setEmployee()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Employee
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		<template v-slot:item.employee_active="{ item }">
        <v-simple-checkbox
          v-model="item.employee_active"
          disabled
        ></v-simple-checkbox>
      </template>
		</v-data-table>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "employees",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Government ID", value: "government_id" },
				{ text: "Firstname", value: "firstname" },
				{ text: "Lastname", value: "surname" },
				{ text: "Maidenname", value: "maidenname" },
				{ text: "Teacher display", value: "teacher_name" },
				{ text: "Teacher Abbreviation", value: "teacher_abbreviation" },
				{ text: "Bank", value: "tbl_sys_bank_type.name" },
				{ text: "Account number", value: "acctbnk" },
				{ text: "Function", value: "tbl_sys_function.name" },
				{ text: "E-mail", value: "email" },
				{ text: "E-mail OSBOD", value: "osbod_email" },
				{ text: "Visible", value: "employee_active" }

			],
			// semesters: [],
			// studies: [],
			// subjects: [],
			// subjecttypes: [],
			// selected_subject: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getEmployees();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudySubjecttype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		// school() {
		// 	return this.$store.getters.getSchool;
		// }
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/employee/update/" + id
			});
		},
		setEmployee: function() {
			this.$router.push({
				path: "/schooladmin/employee/new"
			});
		},
		getEmployees: function() {
			var self = this;
			this.loading = true;
			ax.get("/employee/all_active").then(function(response) {
					// console.log(response.data);
				self.data = response.data;
				console.log("Employees fetched...");
				self.loading = false;
			});
		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>